import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Link, Switch, Route, Redirect,
} from 'react-router-dom';
import '../styles/SplashScreen.css';
import NoBoundariesLogo from '../images/NoBoundries_logo.svg';
import logo from '../images/Subaru_logo_white.svg';
import Modal from './Modal';

const SplashScreen = ({ loggedIn }) => {
  if (loggedIn) {
    return <Redirect to="/quiz" />;
  }

  return (
    <div className="SplashScreen">
      <div className="SplashScreen-header flex items-center justify-end h3">
        <Link className="SplashScreen-loginLink pr3" to="/signin">Sign In</Link>
      </div>
      <div className="center tc">
        <div className="w-90 mw7-ns pv4 pv5-ns center">
          <img alt="Subaru No Boundaries" src={NoBoundariesLogo} />
        </div>
        <div className="Challenge-button-container w-100 absolute center">
          <Link to="/signup">
            <div className="Challenge-button pa3 b white ttu tracked w-70 w-40-ns mw5-ns center">Take the Challenge</div>
          </Link>
          <div className="h2 pv3 pv4-ns">
            <img alt="Subaru" src={logo} />
          </div>
        </div>

      </div>
      <Switch>
        <Route path="/signup" component={Modal} />
        <Route path="/signin" component={Modal} />
        <Route path="/forgot-password" component={Modal} />
      </Switch>
    </div>
  );
};

SplashScreen.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    loggedIn: state.loggedIn,
  };
}

export default connect(mapStateToProps)(SplashScreen);



// WEBPACK FOOTER //
// ./src/components/SplashScreen.js